// get an array of ids that are not folders
// and are after the last folder
const getTrailingItems = ({
  items,
  children,
}) => children.reduce((all, id) => {
  const item = items[id]
  if(item.type == 'folder') return []
  return all.concat([id])
}, [])


const getLastFolder = ({
  items,
  children,
}) => children.reduce((all, id) => {
  const item = items[id]
  if(item.type == 'folder') return item.id
  return all
}, '')



module.exports = {
  getTrailingItems,
  getLastFolder,
}